import React from "react";
import Header from "@/scenes/_shared/header";
import { useStateContext } from "@/components/state";
import useApi from "@/synega/hooks/useApi";
import { useFiles } from "@/components/form/file-input";
import usePages from "@/scenes/finn/stage/pages";
import Form from "@/scenes/_shared/stages/form";
import useHiddenInput from "@/components/form/hidden-input";

const Finn = () => {
    const api = useApi();
    const fileHandler = useFiles();
    const context = useStateContext();
    const { state, dispatch } = context;

    useHiddenInput({
        name: "custom_fields[partner]", default: "Finn.no",
    })

    const submit = async () => {
        if (state?.conditions?.locked) return;

        const promise = state?.client?.id ?
            api.patch(`/leads/finn/${state?.client?.id}`, context.data) :
            api.post("/leads/finn", context.data);

        dispatch({ conditions: { locked: true }})
        promise.then(res => {
            if (res?.data?.id) {
                dispatch({ envelope: { id: res?.data?.id }})
                return res?.data?.id;
            }

            return state?.client?.id;
        }).then(async id => {
            if (!id) throw new Error("Oppstod feil under opprettelsen av oppgaven");

            const files = await fileHandler.all();
            for (const item of files) {
                const data = await fileHandler.data(item);
                await api.post(`/leads/${id}/upload`, {
                    ...data,
                    tags: ["USER UPLOADED"],
                })
            }

            await api.post(`/leads/${id}/dispatch`);
        }).then(() => {
            setTimeout(() => {
                dispatch({ conditions: { submitted: true }})
            }, 500)
        }).catch(error => {
            dispatch({ conditions: { locked: false }})
            console.warn(error?.response?.data?.messages);
        })
    }
    const pages = usePages({ submit })

    if (state?.conditions?.submitted) {
        return (
            <main>
                <section className="full card">
                    <div className="section__header mb-15 sm-hidden--hard">
                        <div/>
                        <div>
                            <h1>
                                Da var det gjort!
                            </h1>
                        </div>
                        <div/>
                    </div>

                    <div className="section__header mb-6 md-hidden--hard lg-hidden--hard">
                        <div/>
                        <div/>
                        <div>
                            <h1>
                                Da var det gjort!
                            </h1>
                        </div>
                    </div>

                    <div className="banner__image--animated mb-3 sm-mb-6">
                        <img
                            decoding="async"
                            src="/static/images/happy.webp"
                            alt="La oss komme i gang og løse krøllen!"
                        />
                    </div>

                    <p className="align--centre mt-6">
                        Takk for at du fylte ut skjema. Så fort vi har fått vurdert din sak vil du bli kontaktet.
                    </p>
                </section>
            </main>
        );
    }

    return (
        <main>
            <section className="full card">
                <Header>
                    <h1>
                        { state?.scenes?.header ?? "..." }
                    </h1>
                </Header>

                <Form {...pages}/>
            </section>
        </main>
    )
}

export default Finn;
